import { useAuth } from "../App";

// Minimal i18n: retreat guests get German UI copy on Home / Calendar / nav. Keys are the English strings.
const DE = {
  "Good morning": "Guten Morgen",
  "Good afternoon": "Guten Tag",
  "Good evening": "Guten Abend",
  "Today": "Heute",
  "Tomorrow": "Morgen",
  "Today at Savi": "Heute in der Villa Savi",
  "Nothing on the calendar today.": "Heute steht nichts im Kalender.",
  "This week": "Diese Woche",
  "Coming up": "Demnächst",
  "Calendar →": "Kalender →",
  "Quick actions": "Schnellzugriff",
  "WiFi": "WLAN",
  "Tap to copy password": "Tippen, um das Passwort zu kopieren",
  "WiFi password copied": "WLAN-Passwort kopiert",
  "Rides": "Mitfahren",
  "Offer or find a lift": "Fahrt anbieten oder finden",
  "Offer or request": "Anbieten oder suchen",
  "today": "heute",
  "Area guide": "Umgebung",
  "Beaches, trails & town": "Strände, Wanderwege & Stadt",
  "Handbook": "Handbuch",
  "House info & tips": "Infos zum Haus & Tipps",
  "Weather": "Wetter",
  "From the house": "Aus dem Haus",
  "Latest updates": "Neuigkeiten",
  "You asked, we did": "Ihr habt gefragt, wir haben's gemacht",
  "More at Savi": "Mehr in der Villa Savi",
  "Savi Library": "Savi Bibliothek",
  "Reads & recipes": "Lesestoff & Rezepte",
  "Host a talk": "Einen Talk halten",
  "20 min on anything": "20 Minuten über irgendwas",
  "Got an idea?": "Eine Idee?",
  "Tell Steve in 30s": "Sag's Steve in 30 Sekunden",
  "Sober Nomads": "Sober Nomads",
  "Our free community": "Unsere kostenlose Community",
  "Tag us": "Markier uns",
  "✓ In": "✓ Dabei",
  "In?": "Dabei?",
  "I'm in!": "Ich bin dabei!",
  "You're going — tap to cancel": "Du bist dabei — tippen zum Absagen",
  "Going": "Dabei",
  "Nobody's confirmed yet — be the first 🙌": "Noch niemand bestätigt — sei die erste Person 🙌",
  "Nothing on the calendar yet — tap + to add": "Noch nichts im Kalender",
  "Add": "Hinzufügen",
  "Loading…": "Lädt…",
  "Lift to": "Fahrt nach",
  "Lift wanted to": "Fahrt gesucht nach",
  "seat left": "Platz frei",
  "seats left": "Plätze frei",
  "seat needed": "Platz gesucht",
  "seats needed": "Plätze gesucht",
  "Full": "Voll",
  "Yours": "Deine",
  "Join": "Mitfahren",
  "I can drive": "Ich fahre",
  "✓ Seat": "✓ Platz",
  "✓ Driving": "✓ Ich fahre",
  "back": "zurück",
  "Home": "Start",
  "People": "Leute",
  "Guide": "Umgebung",
  "Profile": "Profil",
  "Feed": "Feed",
  "Map": "Karte",
  "Community": "Community",
  "Everyone on the retreat": "Alle vom Retreat",
  "Programme": "Programm",
  "The full retreat schedule": "Das ganze Retreat-Programm",
  "Retreat group": "Die Retreat-Gruppe",
  "Who's in the house": "Wer ist im Haus",
  "Humans": "Menschen",
  "Dogs": "Hunde",
  "Cats": "Katzen",
  "Meet your team": "Das Savi-Team",
  "Current Residents": "Aktuelle Bewohner:innen",
  "Furry friends at Savi": "Die Vierbeiner der Villa Savi",
  "Savi resident dogs": "Die Hunde der Villa Savi",
  "Guest pets": "Haustiere der Gäste",
  "person": "Person",
  "people": "Personen",
  "Stay updated on what's happening at Savi": "Alles, was in der Villa Savi gerade passiert",
  "Clear all": "Alle löschen",
  "No updates yet": "Noch keine Neuigkeiten",
  "Check back soon for community updates": "Schau bald wieder vorbei",
  "One-off": "Programmpunkt",
  "Citizen of the world": "Weltbürger:in",
  "Community profiles will appear here once more members complete onboarding.": "Sobald sich alle eingerichtet haben, erscheinen hier die Profile.",
  "Day": "Tag",
  "of": "von",
  "with": "mit",
  "starts in": "beginnt in",
  "day": "Tag",
  "days": "Tagen",
  "wrapped — thank you": "vorbei — danke euch",
  "Morning": "Vormittag",
  "Midday": "Mittag",
  "Afternoon": "Nachmittag",
  "Evening": "Abend",
  "Monday": "Montag",
  "Tuesday": "Dienstag",
  "Wednesday": "Mittwoch",
  "Thursday": "Donnerstag",
  "Friday": "Freitag",
  "Saturday": "Samstag",
  "Sunday": "Sonntag",
  "by": "von",
  "Previous week": "Vorherige Woche",
  "Next week": "Nächste Woche",
  "Who's going": "Wer kommt",
  "+ Add an event": "+ Programmpunkt hinzufügen",
  "Going shopping?": "Einkaufen?",
  "Alert the whole house so they can add to the list — I'm leaving in…": "Sag dem Haus Bescheid, damit alle noch was auf die Liste setzen können — ich fahre in…",
  "Weekly Recurring": "Wöchentlich",
  "Special Event": "Programmpunkt",
  "Welcome back": "Willkommen zurück",
  "Updates": "Neuigkeiten",
  "Stay in the loop": "Bleib auf dem Laufenden",
  "Your Savi journey": "Deine Zeit in der Villa Savi",
  "Mon": "Mo", "Tue": "Di", "Wed": "Mi", "Thu": "Do", "Fri": "Fr", "Sat": "Sa", "Sun": "So",
};

export const langFor = (user) => (user?.guest_type === "retreat" ? "de" : "en");
export const localeFor = (user) => (langFor(user) === "de" ? "de-DE" : "en-GB");
export const translate = (user, key) => (langFor(user) === "de" && DE[key]) || key;

export const useT = () => {
  const { user } = useAuth();
  const t = (key) => translate(user, key);
  return { t, lang: langFor(user), locale: localeFor(user), isDe: langFor(user) === "de" };
};
